import Icon from '../components/Icon';

const CollFoliage = Icon(
  'coll-foliage',
  <>
    <path d="M12.203.38c3.354 3.183 3.68 8.06.805 11.496v2.839c1.225-1.856 3.18-4.468 5.134-5.633 3.186-1.9 5.836-1.433 5.858-1.429 0 5.337-6.886 8.447-10.992 9.022v5.266c1.225-1.856 3.18-4.468 5.134-5.633 3.189-1.902 5.84-1.431 5.858-1.428 0 5.679-7.799 8.835-11.745 9.1a4 4 0 0 1-.503 0C7.805 23.715 0 20.558 0 14.88c.018-.003 2.677-.474 5.866 1.428 1.959 1.168 3.917 3.788 5.142 5.645v-5.278c-4.106-.575-11-3.685-11-9.022.021-.004 2.68-.471 5.866 1.429 1.954 1.165 3.908 3.777 5.134 5.633V12.19C8.243 8.81 8.39 4.07 11.615.907q.284-.277.588-.526" />
  </>
);

export default CollFoliage;
